import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:col-span-2 lg:grid-cols-10 gap-3 mt-3" }
const _hoisted_2 = { class: "flex flex-col md:col-span-2 lg:col-span-5" }
const _hoisted_3 = { class: "flex flex-col lg:col-span-5" }
const _hoisted_4 = { class: "relative inline-block p-2 border border-next-neu hover:border-next-orange group mr-2 mb-2" }
const _hoisted_5 = { class: "mr-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex flex-col lg:col-span-4" }
const _hoisted_8 = { class: "flex flex-col lg:col-span-4" }
const _hoisted_9 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_10 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_11 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_12 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_13 = { class: "flex flex-col lg:col-span-4" }
const _hoisted_14 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_15 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_16 = { class: "flex flex-col lg:col-span-3" }
const _hoisted_17 = { class: "flex flex-col lg:col-span-3" }
const _hoisted_18 = { class: "flex flex-col lg:col-span-4" }
const _hoisted_19 = { class: "flex flex-col lg:col-span-6" }
const _hoisted_20 = { class: "text-sm flex flex-col whitespace-normal" }
const _hoisted_21 = { class: "md:col-span-2 lg:col-span-4" }
const _hoisted_22 = { class: "pl-3 list-disc" }
const _hoisted_23 = { class: "flex flex-col lg:col-span-6" }
const _hoisted_24 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_25 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_26 = { class: "ml-2" }
const _hoisted_27 = { class: "flex flex-col lg:col-span-4" }
const _hoisted_28 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_29 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_30 = { class: "ml-2" }
const _hoisted_31 = { class: "flex flex-col lg:col" }
const _hoisted_32 = { class: "flex flex-col lg:col-span-4" }
const _hoisted_33 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_34 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_35 = { class: "ml-2" }
const _hoisted_36 = { class: "flex flex-col lg:col" }
const _hoisted_37 = { class: "flex flex-col lg:col-span-3" }
const _hoisted_38 = { class: "flex flex-col lg:col-span-3" }
const _hoisted_39 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_40 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_41 = { class: "flex flex-col lg:col-span-3" }
const _hoisted_42 = { class: "flex flex-col lg:col-span-3" }
const _hoisted_43 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_44 = { class: "flex flex-col lg:col-span-2" }
const _hoisted_45 = { class: "flex flex-col lg:col-span-10 col-span-2" }
const _hoisted_46 = { class: "flex items-end grid grid-cols-2 lg:col-start-7 lg:col-span-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Field, {
        field_name: "Titolo",
        required: !_ctx.sottoprogetto_model?.titolo?.length,
        modelValue: _ctx.sottoprogetto_model.titolo,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sottoprogetto_model.titolo) = $event)),
        placeholder: "Nome del sottoprogetto",
        errors: _ctx.getErrors('titolo')
      }, null, 8, ["required", "modelValue", "errors"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Field, {
        field_name: "Business Unit",
        required: !_ctx.buAutocomplete?.selection,
        placeholder: "Codice commessa",
        errors: _ctx.getErrors('business_unit_id')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            searchable: true,
            loading: _ctx.buAutocomplete.isLoading,
            "internal-search": true,
            trackBy: "id",
            label: "label",
            modelValue: _ctx.buAutocomplete.selection,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
            options: _ctx.buAutocomplete.options,
            multiple: false,
            class: "next-vue-multiselect-single",
            "close-on-select": true,
            "clear-on-select": true,
            placeholder: "Business Unit",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona"
          }, {
            tag: _withCtx(({option, remove}) => [
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(option.label), 1),
                _createElementVNode("i", {
                  tabindex: "1",
                  onClick: _withModifiers(($event: any) => (remove(option)), ["stop","prevent"]),
                  class: "cursor-pointer fa fa-times text-next-gray-md group-hover:text-next-orange p-0"
                }, null, 8, _hoisted_6)
              ])
            ]),
            _: 1
          }, 8, ["loading", "modelValue", "options"])
        ]),
        _: 1
      }, 8, ["required", "errors"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Field, {
        field_name: "Data di inizio",
        required: !_ctx.sottoprogetto_model?.data_inizio,
        errors: _ctx.getErrors('data_inizio'),
        "input-attrs": {max:_ctx.sottoprogetto_model.data_fine},
        placeholder: "Data di inizio",
        type: "date",
        modelValue: _ctx.sottoprogetto_model.data_inizio,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sottoprogetto_model.data_inizio) = $event))
      }, null, 8, ["required", "errors", "input-attrs", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Field, {
        field_name: "Data di fine",
        required: !_ctx.sottoprogetto_model?.data_fine,
        errors: _ctx.getErrors('data_fine'),
        "input-attrs": {min:_ctx.sottoprogetto_model.data_inizio},
        placeholder: "Data di fine",
        type: "date",
        modelValue: _ctx.sottoprogetto_model.data_fine,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sottoprogetto_model.data_fine) = $event))
      }, null, 8, ["required", "errors", "input-attrs", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Field, {
        field_name: "Anno",
        required: !_ctx.sottoprogetto_model?.anno,
        modelValue: _ctx.sottoprogetto_model.anno,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sottoprogetto_model.anno) = $event)),
        errors: _ctx.getErrors('anno'),
        placeholder: "Anno"
      }, null, 8, ["required", "modelValue", "errors"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_Field, {
        field_name: "Budget di apertura",
        required: !_ctx.sottoprogetto_model?.budget,
        modelValue: _ctx.sottoprogetto_model.budget,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sottoprogetto_model.budget) = $event)),
        type: "number",
        "input-attrs": {step:.01},
        errors: _ctx.getErrors('budget'),
        placeholder: "Budget"
      }, null, 8, ["required", "modelValue", "errors"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_Field, {
        field_name: "Tipo operazione",
        required: !_ctx.tipoOperazioniAutocomplete?.selection,
        errors: _ctx.getErrors('tipo_operazione_id'),
        placeholder: "Tipo operazione"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.tipoOperazioniAutocomplete.selection,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tipoOperazioniAutocomplete.selection) = $event)),
            options: _ctx.tipoOperazioniAutocomplete.options,
            track_by: "id",
            label: "descrizione",
            placeholder: "Tipo evento",
            deselectLabel: "",
            selectedLabel: "",
            selectLabel: "",
            onSearchChange: _ctx.tipoOperazioniAutocomplete.search,
            "close-on-select": true,
            "clear-on-select": true,
            class: "next-vue-multiselect-single"
          }, null, 8, ["modelValue", "options", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["required", "errors"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Field, {
        field_name: "Tipo di IVA",
        required: !_ctx.tipo_iva_selection,
        errors: _ctx.getErrors('tipo_iva'),
        placeholder: "Tipo di IVA"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.tipo_iva_selection,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tipo_iva_selection) = $event)),
            options: _ctx.tipo_iva_options,
            track_by: "id",
            label: "label",
            placeholder: "Tipo iva",
            deselectLabel: "",
            selectedLabel: "",
            selectLabel: "",
            "close-on-select": true,
            "clear-on-select": true,
            class: "next-vue-multiselect-single"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["required", "errors"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_Field, {
        field_name: "Descrizione",
        modelValue: _ctx.sottoprogetto_model.descrizione,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sottoprogetto_model.descrizione) = $event)),
        errors: _ctx.getErrors('descrizione'),
        placeholder: "Descrizione"
      }, null, 8, ["modelValue", "errors"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_Field, {
        field_name: "Gara",
        required: !_ctx.gara_selection,
        errors: _ctx.getErrors('gara'),
        placeholder: "Gara"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.gara_selection,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.gara_selection) = $event)),
            options: _ctx.si_no_options,
            track_by: "id",
            label: "label",
            placeholder: "Gara",
            deselectLabel: "",
            selectedLabel: "",
            selectLabel: "",
            "close-on-select": true,
            "clear-on-select": true,
            class: "next-vue-multiselect-single"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["required", "errors"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_Field, {
        field_name: "Data di arrivo Brief",
        required: !_ctx.sottoprogetto_model?.data_arrivo,
        errors: _ctx.getErrors('data_arrivo'),
        modelValue: _ctx.sottoprogetto_model.data_arrivo,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sottoprogetto_model.data_arrivo) = $event)),
        type: "date"
      }, null, 8, ["required", "errors", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_Field, {
        field_name: "Data consegna Progetto/Offerta",
        required: !_ctx.sottoprogetto_model?.data_consegna,
        errors: _ctx.getErrors('data_consegna'),
        modelValue: _ctx.sottoprogetto_model.data_consegna,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.sottoprogetto_model.data_consegna) = $event)),
        type: "date"
      }, null, 8, ["required", "errors", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_Field, {
        field_name: "Ipotesi data di aggiudicazione",
        required: false,
        modelValue: _ctx.sottoprogetto_model.ipotesi_data_aggiudicazione,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.sottoprogetto_model.ipotesi_data_aggiudicazione) = $event)),
        type: "date",
        errors: _ctx.getErrors('ipotesi_data_aggiudicazione')
      }, null, 8, ["modelValue", "errors"])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_Field, {
        field_name: " ",
        errors: _ctx.getErrors('new_business')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Checkbox, {
            checkClass: "h-4 w-4",
            checked: _ctx.sottoprogetto_model.new_business,
            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sottoprogetto_model.new_business = $event.target.checked))
          }, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [
              _createTextVNode(" Progetto New Business ")
            ])),
            _: 1
          }, 8, ["checked"])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_Field, { field_name: "Sottoprogetto intragruppo" }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            ref: "select",
            disabled: !_ctx.canSetIntragruppo,
            "internal-search": false,
            "close-on-select": true,
            "clear-on-select": true,
            class: "next-vue-multiselect-single",
            placeholder: "Sottoprogetto",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona",
            label: "cod_nodo",
            options: _ctx.sottoprogettoAutocomplete.options,
            onSearchChange: _ctx.sottoprogettoAutocomplete.search,
            modelValue: _ctx.sottoprogettoAutocomplete.selection,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.sottoprogettoAutocomplete.selection) = $event))
          }, {
            option: _withCtx(({option}) => [
              _createElementVNode("span", _hoisted_20, [
                _createElementVNode("span", null, "Cod: " + _toDisplayString(option.cod_nodo), 1),
                _createElementVNode("span", null, "BU: " + _toDisplayString(option.bu_label), 1),
                _createElementVNode("span", null, "Titolo: " + _toDisplayString(option.titolo), 1)
              ])
            ]),
            _: 1
          }, 8, ["disabled", "options", "onSearchChange", "modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _cache[32] || (_cache[32] = _createElementVNode("p", { class: "font-bold" }, "Head of Client / Client Director", -1)),
      _withDirectives(_createElementVNode("ul", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts_cliente, (a) => {
          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(a.name), 1))
        }), 256))
      ], 512), [
        [_vShow, _ctx.accounts_cliente.length]
      ]),
      _withDirectives(_createElementVNode("p", null, "Nessun utente presente per la bu scelta", 512), [
        [_vShow, !_ctx.accounts_cliente.length]
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_component_Field, {
        field_name: "Account Gestionale",
        required: !_ctx.accountAutocomplete?.selection?.length,
        errors: _ctx.getErrors('accounts')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.accountAutocomplete.selection,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.accountAutocomplete.selection) = $event)),
            options: _ctx.accountAutocomplete.options,
            multiple: true,
            onSearchChange: _ctx.accountAutocomplete.search,
            "close-on-select": false,
            "clear-on-select": false,
            placeholder: "Accounts",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona",
            tagPlaceholder: "Aggiungi account",
            class: "next-vue-multiselect",
            "track-by": "id",
            label: "name"
          }, {
            noResult: _withCtx(() => _cache[33] || (_cache[33] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            tag: _withCtx(({option, remove}) => [
              _createVNode(_component_MultiselectOption, {
                onRemove: ($event: any) => (remove(option))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(option.bu_label || ' '), 1),
                  _createElementVNode("span", null, _toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1032, ["onRemove"])
            ]),
            option: _withCtx(({option}) => [
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(option.bu_label), 1),
                _createElementVNode("span", _hoisted_26, _toDisplayString(option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["required", "errors"])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_Field, {
        field_name: "PM",
        errors: _ctx.getErrors('project_managers')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.projectManagersAutocomplete.selection,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.projectManagersAutocomplete.selection) = $event)),
            options: _ctx.projectManagersAutocomplete.options,
            multiple: true,
            disabled: _ctx.sottoprogetto_model.pm_esterno,
            onSearchChange: _ctx.projectManagersAutocomplete.search,
            "close-on-select": false,
            "clear-on-select": false,
            placeholder: "Project Managers",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona",
            tagPlaceholder: "Aggiungi PM",
            class: "next-vue-multiselect",
            "track-by": "id",
            label: "name"
          }, {
            noResult: _withCtx(() => _cache[34] || (_cache[34] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            tag: _withCtx(({option, remove}) => [
              _createVNode(_component_MultiselectOption, {
                onRemove: ($event: any) => (remove(option))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(option.bu_label || ' '), 1),
                  _createElementVNode("span", null, _toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1032, ["onRemove"])
            ]),
            option: _withCtx(({option}) => [
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(option.bu_label), 1),
                _createElementVNode("span", _hoisted_30, _toDisplayString(option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "disabled", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createVNode(_component_Field, {
        field_name: "Esterno",
        required: false,
        errors: _ctx.getErrors('pm_esterno')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Checkbox, {
            checkClass: "h-4 w-4",
            checked: _ctx.sottoprogetto_model.pm_esterno,
            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sottoprogetto_model.pm_esterno = !_ctx.sottoprogetto_model.pm_esterno)),
            for_id: "pm_esterno"
          }, null, 8, ["checked"])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createVNode(_component_Field, {
        field_name: "Produzione",
        errors: _ctx.getErrors('produzione')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.direttoriProduzioneAutocomplete.selection,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.direttoriProduzioneAutocomplete.selection) = $event)),
            options: _ctx.direttoriProduzioneAutocomplete.options,
            multiple: true,
            onSearchChange: _ctx.direttoriProduzioneAutocomplete.search,
            disabled: _ctx.sottoprogetto_model.produzione_esterna,
            "close-on-select": false,
            "clear-on-select": false,
            placeholder: "Produzione",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona",
            tagPlaceholder: "Aggiungi direttore",
            class: "next-vue-multiselect",
            "track-by": "id",
            label: "name"
          }, {
            noResult: _withCtx(() => _cache[35] || (_cache[35] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            tag: _withCtx(({option, remove}) => [
              _createVNode(_component_MultiselectOption, {
                onRemove: ($event: any) => (remove(option))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(option.bu_label || ' '), 1),
                  _createElementVNode("span", null, _toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1032, ["onRemove"])
            ]),
            option: _withCtx(({option}) => [
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_34, _toDisplayString(option.bu_label), 1),
                _createElementVNode("span", _hoisted_35, _toDisplayString(option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "onSearchChange", "disabled"])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createVNode(_component_Field, {
        field_name: "Esterno",
        required: false,
        errors: _ctx.getErrors('produzione_esterna')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Checkbox, {
            checkClass: "h-4 w-4",
            checked: _ctx.sottoprogetto_model.produzione_esterna,
            onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sottoprogetto_model.produzione_esterna = !_ctx.sottoprogetto_model.produzione_esterna)),
            for_id: "produzione_esterna"
          }, null, 8, ["checked"])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_Field, {
        field_name: "Paese",
        required: false,
        modelValue: _ctx.sottoprogetto_model.destinazione,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.sottoprogetto_model.destinazione) = $event)),
        errors: _ctx.getErrors('destinazione'),
        placeholder: "Paese"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.paeseAutocomplete.selection,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.paeseAutocomplete.selection) = $event)),
            options: _ctx.paeseAutocomplete.options,
            onSearchChange: _ctx.paeseAutocomplete.search,
            "close-on-select": true,
            "clear-on-select": true,
            placeholder: "Paese",
            deselectLabel: "Deseleziona",
            selectedLabel: "Selezionato",
            selectLabel: "Seleziona",
            class: "next-vue-multiselect-single",
            "track-by": "id",
            label: "nome"
          }, {
            noResult: _withCtx(() => _cache[36] || (_cache[36] = [
              _createTextVNode("Nessun elemento trovato.")
            ])),
            _: 1
          }, 8, ["modelValue", "options", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["modelValue", "errors"])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createVNode(_component_Field, {
        field_name: "Città",
        required: false,
        modelValue: _ctx.sottoprogetto_model.citta,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.sottoprogetto_model.citta) = $event)),
        type: "text",
        errors: _ctx.getErrors('citta'),
        placeholder: "Città"
      }, null, 8, ["modelValue", "errors"])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createVNode(_component_Field, {
        field_name: "Segreteria",
        required: false,
        errors: _ctx.getErrors('segreteria'),
        placeholder: "Segreteria"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.segreteria_selection,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.segreteria_selection) = $event)),
            options: _ctx.si_no_options,
            track_by: "id",
            label: "label",
            placeholder: "Segreteria",
            deselectLabel: "",
            selectedLabel: "",
            selectLabel: "",
            "close-on-select": true,
            "clear-on-select": true,
            class: "next-vue-multiselect-single"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createVNode(_component_Field, {
        field_name: "Tipo di evento",
        required: false,
        errors: _ctx.getErrors('tipo_evento'),
        placeholder: "Tipo di evento"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.tipo_evento_selection,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.tipo_evento_selection) = $event)),
            options: _ctx.tipo_evento_options,
            track_by: "id",
            label: "label",
            placeholder: "Tipo evento",
            deselectLabel: "",
            selectedLabel: "",
            selectLabel: "",
            "close-on-select": true,
            "clear-on-select": true,
            class: "next-vue-multiselect-single"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_Field, {
        field_name: "Biglietteria",
        required: false,
        errors: _ctx.getErrors('biglietteria'),
        placeholder: "Biglietteria"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.biglietteria_selection,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.biglietteria_selection) = $event)),
            options: _ctx.si_no_options,
            track_by: "id",
            label: "label",
            placeholder: "Biglietteria",
            deselectLabel: "",
            selectedLabel: "",
            selectLabel: "",
            "close-on-select": true,
            "clear-on-select": true,
            class: "next-vue-multiselect-single"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createVNode(_component_Field, {
        field_name: "Periodicità",
        required: _ctx.requiredPeriodicita,
        errors: _ctx.getErrors('periodicita'),
        placeholder: "Periodicità"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            modelValue: _ctx.periodicita_selection,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.periodicita_selection) = $event)),
            options: _ctx.periodicita_options,
            track_by: "id",
            label: "label",
            placeholder: "Periodicità",
            deselectLabel: "",
            selectedLabel: "",
            selectLabel: "",
            "close-on-select": true,
            "clear-on-select": true,
            class: "next-vue-multiselect-single"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["required", "errors"])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createVNode(_component_Field, {
        field_name: "Numero Pax",
        required: false,
        errors: _ctx.getErrors('numero_pax'),
        modelValue: _ctx.sottoprogetto_model.numero_pax,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.sottoprogetto_model.numero_pax) = $event))
      }, null, 8, ["errors", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createVNode(_component_Field, {
        field_name: "CIG",
        required: false,
        errors: _ctx.getErrors('cig'),
        modelValue: _ctx.sottoprogetto_model.cig,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.sottoprogetto_model.cig) = $event))
      }, null, 8, ["errors", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createVNode(_component_Field, {
        field_name: "Note",
        required: false,
        errors: _ctx.getErrors('note')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.sottoprogetto_model.note) = $event)),
            class: "bg-next-gray-md hover:bg-white p-2 h-full w-full",
            placeholder: "Note"
          }, null, 512), [
            [_vModelText, _ctx.sottoprogetto_model.note]
          ])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$emit('chiudi'))),
        class: "px-4 grow mr-1 h-10"
      }, {
        default: _withCtx(() => _cache[37] || (_cache[37] = [
          _createTextVNode(" Chiudi ")
        ])),
        _: 1
      }),
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.creaSottoProgetto,
        disabled: _ctx.loading,
        loading: _ctx.loading,
        class: "grow ml-1 h-10 flex items-center justify-center"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_Spinner, { class: "w-4 h-4 mr-4" }, null, 512), [
            [_vShow, _ctx.loading]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.create ? 'Aggiungi' : 'Salva'), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled", "loading"])
    ])
  ]))
}